import Checkbox from '@mui/material/Checkbox';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { houseStatsSelectors } from 'app-components/flux/house-stats';
import { loadState, useLoadState } from 'app-components/hooks/utils';
import emptyBoxDisabled from 'assets/illustrations/Empty-box-disabled.png';
import paperAirplaneCrash from 'assets/illustrations/Plane-Crash.png';
import kbb from 'assets/logos/kbb.png';
import StdDialogContent from 'components/Dialogs/StdDialogContent';
import StdDialogForm from 'components/Dialogs/StdDialogForm';
import QAmountField from 'components/QAmountField';
import QButton from 'components/QButton';
import ZeroStateView from 'components/ZeroStateView';
import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
//
import React, { useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { showVehicleDialog } from '../actions';

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    height: 420,
  },
  accountName: {
    width: 550,
    textAlign: 'left',
  },
  headlineIcon: {
    height: 30,
    top: 30,
    left: 0,
  },
  stats: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    borderRadius: 20,
    width: 705,
    height: 187,
    marginTop: 12,
    marginBottom: 20,
  },
  subsetText: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    paddingTop: 10,
  },
  assetText: {
    fontSize: 24,
  },
  textFontSize: {
    fontSize: 16,
  },
  statsDiv: {
    width: 500,
    padding: 20,
    textAlign: 'center',
  },
  centerIncompatibleText: {
    fontSize: 18,
    paddingTop: 10,
    paddingBottom: 32,
  },
  dialogIncompatible: {
    textAlign: 'center',
    paddingTop: 50,
  },
  addManualButton: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: 345,
  },
  flex: {
    display: 'flex',
  },
  manualButton: {
    paddingTop: 30,
  },
  notRight: {
    fontSize: 16,
    paddingRight: 16,
  },
}));

const KBBStats = (props) => {
  const { asset, setState, setKbbUpdate, kbbUpdate, amount, setAmountInternal, setAccountNameQCS } = props;
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const houseStatsView = useLoadState(houseStatsSelectors);
  const showTryAgainView =
    loadState.tryAgainStates.includes(houseStatsView) || loadState.updateRequiredStates.includes(houseStatsView);
  const showNoDataView = loadState.noDataStates.includes(houseStatsView);
  const showReadyView = loadState.readyStates.includes(houseStatsView);

  // TODO update this with the kbb stats request
  // const selector = useSelector(houseStatsSelectors.getHouseStatsById);
  // TODO update this with the kbb stats request

  // let data;
  // selector.forEach((value) => {
  //   data = value;
  // });

  const refreshData = useCallback(() => {
    dispatch(showVehicleDialog());
  }, [dispatch]);

  const addManualAcc = () => {
    setState('manualAcc');
  };

  let mainView = '';
  if (showReadyView) {
    mainView = 'READY';
  } else if (showNoDataView) {
    mainView = 'EMPTY';
  } else if (showTryAgainView) {
    mainView = 'FAILED';
  }
  mainView = 'READY';

  const updateAmount = useCallback(
    (e) => {
      const newAmount = Number(e.target.value);
      setAmountInternal(newAmount);
    },
    [setAmountInternal],
  );

  const renderForm = (formikBag) => {
    const { values } = formikBag;

    const handleContinue = () => {
      setAmountInternal(amount);
      setAccountNameQCS(asset.name);
      setState('confirm');
    };
    if (mainView === 'READY' || mainView === 'EMPTY') {
      return (
        <StdDialogForm component={Form}>
          <StdDialogContent>
            {asset.name ? (
              <DialogContent className={classes.root}>
                <Grid item container>
                  <Typography className={classes.assetText}>Review vehicle value</Typography>
                  <div className={classes.stats}>
                    <div className={classes.statsDiv}>
                      <Typography className={classes.textFontSize}>{asset.name}</Typography>
                      <Typography className={classes.textFontSize}>VIN: {asset.vin}</Typography>
                      <Typography className={classes.subsetText}>
                        {' '}
                        {asset.type} · {asset.specType}
                      </Typography>
                      <Typography className={classes.subsetText} style={{ paddingBottom: 25 }}>
                        {' '}
                        {asset.engine} · {asset.wheels}
                      </Typography>
                      <img className={classes.headlineIcon} src={kbb} alt='' />
                    </div>
                  </div>
                  <div className={classes.flex}>
                    <QAmountField
                      id='currentValue'
                      editable
                      label='Current Value'
                      noNegatives
                      value={amount}
                      onChange={updateAmount}
                      className={classes.accountName}
                      InputProps={{
                        autoComplete: 'off',
                        maxLength: 32,
                        inputProps: {
                          maxLength: 32,
                        },
                      }}
                    />
                  </div>
                  <Field name='kbbUpdate'>
                    {({ field }) => (
                      <FormControlLabel
                        {...field}
                        control={<Checkbox />}
                        label='Automatically update value every month from Kelley Blue Book.'
                        id='kbbUpdate'
                        checked={kbbUpdate}
                        onChange={(event, checked) => {
                          setKbbUpdate(checked);
                          field.onChange(event, Boolean(checked));
                          if (checked) {
                            formikBag.setFieldValue('kbbUpdate', true);
                          }
                        }}
                      />
                    )}
                  </Field>
                </Grid>
              </DialogContent>
            ) : (
              <div className={classes.dialogIncompatible}>
                <img src={emptyBoxDisabled} alt='' />
                <Typography className={classes.centerIncompatibleText}>Unable to find a matching vehicle.</Typography>
                <QButton
                  variant='outlined'
                  onClick={() => {
                    setState('');
                  }}
                >
                  Try Again
                </QButton>
                <div className={classes.manualButton}>
                  <QButton onClick={() => addManualAcc()}>Add Manually</QButton>
                </div>
              </div>
            )}
          </StdDialogContent>
          {asset.name ? (
            <DialogActions>
              <div className={classes.addManualButton}>
                <Typography className={classes.notRight}>Not Right?</Typography>
                <QButton
                  variant='outlined'
                  onClick={() => {
                    addManualAcc();
                  }}
                >
                  Add Manually
                </QButton>
              </div>
              <QButton
                id='continue-btn'
                variant='contained'
                onClick={handleContinue}
                disabled={!amount && !values.kbbInitial}
              >
                Continue
              </QButton>
            </DialogActions>
          ) : null}
        </StdDialogForm>
      );
    }
    return (
      <ZeroStateView
        className={classes.errorTab}
        button={
          <QButton id={'try-again-button'} variant='outlined' onClick={refreshData}>
            TRY AGAIN
          </QButton>
        }
        id='failed-to-fetch'
        primary='Unable to fetch data'
        secondary="We can't fetch your data from the server. Please try again"
        icon={paperAirplaneCrash}
      />
    );
  };

  const initialVals = { kbbInitial: true };
  return <Formik initialValues={initialVals}>{renderForm}</Formik>;
};

KBBStats.propTypes = {
  setState: PropTypes.func,
  asset: PropTypes.object,
  setAmountInternal: PropTypes.func,
  amount: PropTypes.number,
  setKbbUpdate: PropTypes.func,
  kbbUpdate: PropTypes.bool,
  setAccountNameQCS: PropTypes.func,
};

export default KBBStats;
